module.exports = function() {
  return new Worker(__webpack_public_path__ + "779b40ed14edb3d52ab7.worker.js");
};